<template>
    <component :is="layout">
        <h1 class="heading">Мои файлы</h1>
        <p v-if="files.length === 0">Файлы отсутствуют</p>
        <div v-else class="dataset" :key="file.id" v-for="file in files">
            <h2 class="dataset__title small-heading">{{file.title}}</h2>
            <p class="dataset__description">
                {{file.description}}
            </p>

            <div class="dataset__meta">
                <div>
                    <span class="dataset__meta-title help-text help-text--strong">Дата:</span>
                    <span class="dataset__meta-title help-text help-text--light">
                        {{prettifyDateTime(file.timestamp)}}
                    </span>
                </div>
                <div>
                    <span class="dataset__meta-title help-text help-text--strong">Размер:</span>
                    <span class="dataset__meta-title help-text help-text--light">
                        {{bytesAsGbString(file.size)}}
                    </span>
                </div>
            </div>
            <div class="dataset__links">
                <a :href="file.datafile" class="dataset__download-link link very-strong">Скачать</a>
            </div>
        </div>
    </component>
</template>

<script>
  import SideBar from '../components/SideBar'
  import PageContent from '../components/PageContent'
  import { FilesAPI } from 'api-client'
  import moment from 'moment'

  export default {
    name: 'files',
    components: {
      PageContent,
      SideBar
    },
    data() {
      return {
        layout: 'default-layout',
        files: []
      }
    },
    async created() {
      this.files = await FilesAPI.getFiles()
    },
    methods: {
      bytesAsGbString(bytes) {
        const asGb = bytes / Math.pow(10,9)
        return `${asGb.toFixed(2)} ГБ`
      },
      prettifyDateTime(timeStart) {
        const momentObj =  moment.unix(timeStart)
        return momentObj.calendar(null, {});
      }
    }
  }
</script>

<style lang="sass" scoped>
    .dataset
        margin-bottom: gridSteps(3)

        .dataset__description
            margin-top: 0
            margin-bottom: gridSteps(1)

        .dataset__meta-title
            margin-right: gridSteps(1)

        .dataset__links
            margin-top: gridSteps(2)

        .dataset__download-link
            margin-right: gridSteps(2)
</style>
